import { Component, OnInit } from '@angular/core';
import { IAddressItem } from '../../models/address.interface';
import { AuthService } from '../../services/auth.service';
import { AddressesService } from '../../services/addresses.service';
import { BusinessesService } from '../../services/businesses.service';

@Component({
  selector: 'app-address-selector',
  templateUrl: './address-selector.component.html',
  styleUrls: ['./address-selector.component.scss'],
})
export class AddressSelectorComponent implements OnInit {

  addresses!: IAddressItem[];
  activeAddressUid!: string;

  isGuest: boolean = false;

  constructor(
    private authService: AuthService,
    private addressesService: AddressesService,
    private businessesService: BusinessesService,
  ) { }

  async ngOnInit() {
    this.isGuest = await this.authService.getGuestFlag();

    this.addresses = await this.addressesService.list(this.authService.uid);
    this.activeAddressUid = this.addressesService.currentAddressItemUid;
    this.businessesService.filters = {
      position: this.addressesService.currentAddress.position,
    }
  }

  async changeActiveAddress(e: any) {
    await this.addressesService.setActiveItem(this.authService.uid, e.detail.value);
    this.businessesService.page = 0;
    this.businessesService.filters = {
      position: this.addressesService.currentAddress.position,
      page: 0,
    }
  }

}
